import script from "./MenuDesplegable.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuDesplegable.vue?vue&type=script&setup=true&lang=js"

import "./MenuDesplegable.vue?vue&type=style&index=0&id=d895a742&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d895a742"]])

export default __exports__